import { ManageGeneralFormProvider } from "../../organisms/Provider/ManageGeneralFormProvider";
import { QuickCreateDrawer } from "./QuickCreateDrawer";

/**
 * Manage shell for a Create * drawer: chrome, submit, and form context.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {function(): void} props.onClose
 * @param {string} props.title
 * @param {string=} props.intro
 * @param {!Object} props.formik Formik bag from the feature Manage file.
 * @param {boolean=} props.loading
 * @param {boolean=} props.disabled Defaults to an invalid form.
 * @param {string=} props.rootClassName
 * @param {*} props.children Field markup from the feature Form file.
 * @return {*}
 */
export const QuickCreateManage = ({
  open,
  onClose,
  title,
  intro,
  formik,
  loading = false,
  disabled,
  rootClassName,
  children,
}) => (
  <QuickCreateDrawer
    open={open}
    onClose={onClose}
    title={title}
    intro={intro}
    onSubmit={formik.handleSubmit}
    loading={loading}
    disabled={disabled ?? !formik.isValid}
    rootClassName={rootClassName}
  >
    <ManageGeneralFormProvider formik={formik}>{children}</ManageGeneralFormProvider>
  </QuickCreateDrawer>
);
